import { PerformanceReturn } from '@ddt-web/domain';
import { DateUtil } from '@ddt-web/generic-utils';
import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export class PerformanceReturnBuilder {
	private performanceReturn: PerformanceReturn;

	constructor() {
		this.performanceReturn = new PerformanceReturn();
	}

	public setUniqueId(uniqueId: string): PerformanceReturnBuilder {
		this.performanceReturn.uniqueId = uniqueId;
		return this;
	}

	public setHasReturnsData(returnsJson: any): PerformanceReturnBuilder {
		let hasReturnsData = false;
		if (returnsJson) {
			hasReturnsData = Boolean(returnsJson.oneMonth || returnsJson.threeMonth ||
				returnsJson.oneYearAnnualized || returnsJson.threeYearAnnualized || returnsJson.fiveYearAnnualized ||
				returnsJson.sinceInceptionAnnualized || returnsJson.yearToDate);
		}
		this.performanceReturn.hasReturnsData = hasReturnsData;
		return this;
	}

	public setAsOfDate(asOfDate: number): PerformanceReturnBuilder {
		let date = null;

		if (asOfDate) {
			date = dayjs(asOfDate.toString(), 'YYYYMMDD').format(DateUtil.MODELS_US_DATE_FORMAT);
		}
		this.performanceReturn.asOfDate = date;
		return this;
	}

	public setChartData(chartData: Array<any>): PerformanceReturnBuilder {
		this.performanceReturn.chartData = [];
		if (chartData) {
			this.performanceReturn.chartData = chartData.map(point => {
				return {
					x: point[0],
					y: point[1] * 10000
				};
			});
		}
		return this;
	}

	public setFiveYear(fiveYear: number): PerformanceReturnBuilder {
		this.performanceReturn.fiveYear = fiveYear;
		return this;
	}

	public setLastMonth(lastMonth: number): PerformanceReturnBuilder {
		this.performanceReturn.lastMonth = lastMonth;
		return this;
	}

	public setLastQuarter(lastQuarter: number): PerformanceReturnBuilder {
		this.performanceReturn.lastQuarter = lastQuarter;
		return this;
	}

	public setOneYear(oneYear: number): PerformanceReturnBuilder {
		this.performanceReturn.oneYear = oneYear;
		return this;
	}

	public setThreeYear(threeYear: number): PerformanceReturnBuilder {
		this.performanceReturn.threeYear = threeYear;
		return this;
	}

	public setYearToDate(yearToDate: number): PerformanceReturnBuilder {
		this.performanceReturn.yearToDate = yearToDate;
		return this;
	}

	public setSinceInception(sinceInception: number): PerformanceReturnBuilder {
		this.performanceReturn.sinceInception = sinceInception;
		return this;
	}

	public setBenchmarkName(benchmarkName: string): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkName = benchmarkName;
		return this;
	}

	public setBenchmarkLastMonth(benchmarkLastMonth: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkLastMonth = benchmarkLastMonth;
		return this;
	}

	public setBenchmarkLastQuarter(benchmarkLastQuarter: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkLastQuarter = benchmarkLastQuarter;
		return this;
	}

	public setBenchmarkYearToDate(benchmarkYearToDate: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkYearToDate = benchmarkYearToDate;
		return this;
	}

	public setBenchmarkOneYear(benchmarkOneYear: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkOneYear = benchmarkOneYear;
		return this;
	}

	public setBenchmarkThreeYear(benchmarkThreeYear: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkThreeYear = benchmarkThreeYear;
		return this;
	}

	public setBenchmarkFiveYear(benchmarkFiveYear: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkFiveYear = benchmarkFiveYear;
		return this;
	}

	public setBenchmarkSinceInception(benchmarkSinceInception: number): PerformanceReturnBuilder {
		this.performanceReturn.benchmarkSinceInception = benchmarkSinceInception;
		return this;
	}

	public build(): PerformanceReturn {
		return this.performanceReturn;
	}
}
